import React, {Component} from 'react';
import {connect} from "react-redux";
import FJToolbarCommon from '../view/FJToolbarCommon';
import FJVoice from '../view/FJVoice';
import classNames from "classnames";
import {FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJToolbarDevider from "../view/FJToolbarDevider";
import FJFade from "../view/FJFade";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJToolbarAudioContainer extends Component {
  render() {
    let {
      volume,
      volumeDataChange,
      active,
      fadeIn,
      fadeOut,
      handleFadeInDataChange,
      handleFadeOutDataChange,
      mediaStatus,
      mediaName,
      onLinkFun,
      onRetryFun,
    } = this.props;
    let containerClass = classNames('c-toolbar-audio', {active});
    let mediaSuccess = mediaStatus === FJViewConstant.MEDIA_STATUS_SUCCESS;
    return (
      <FJToolbarCommon  mediaStatus={mediaStatus}
                        mediaName={mediaName}
                        onLinkFun={onLinkFun}
                        onRetryFun={onRetryFun}
                        className={containerClass}>
        <FJVoice disabled={!mediaSuccess}
                 volume={volume}
                 volumeDataChange={volumeDataChange}/>
        <FJToolbarDevider />
        <FJFade disabled={!mediaSuccess}
                fadeIn={fadeIn}
                fadeOut={fadeOut}
                fadeInDataChange={handleFadeInDataChange}
                fadeOutDataChange={handleFadeOutDataChange}/>
      </FJToolbarCommon>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    mediaStatus: state.toolbarAudio.mediaStatus,
    volume: state.toolbarAudio.volume,
    fadeIn: state.toolbarAudio.fadeIn,
    fadeOut: state.toolbarAudio.fadeOut,
    mediaName: state.toolbarAudio.mediaName,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    volumeDataChange: function (type, value) {
      dispatch(FJToolbarAction.audioVolumeDataChangeAction(type, value));
    },
    handleFadeInDataChange: function (type, value) {
      dispatch(FJToolbarAction.audioFadeInDataChangeAction(type, value))
    },
    handleFadeOutDataChange: function (type, value) {
      dispatch(FJToolbarAction.audioFadeOutDataChangeAction(type, value))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarAudioContainer);
